import { type Static, Type } from 'typebox';
import { Value } from 'typebox/value';

export const DEMO_OUTBOX_HEADER = 'x-demo-outbox';

export const DEMO_REAL_EMAIL_HEADER = 'x-demo-real-email';

const DemoOutboxLinkSchema = Type.Object({ label: Type.String(), href: Type.String() });

export const DemoOutboxMessageSchema = Type.Object({
  channel: Type.Union([Type.Literal('email'), Type.Literal('sms')]),
  to: Type.String(),
  purpose: Type.String(),
  code: Type.Optional(Type.String()),
  body: Type.Optional(Type.String()),
  link: Type.Optional(DemoOutboxLinkSchema),
});

export type DemoOutboxMessage = Readonly<Static<typeof DemoOutboxMessageSchema>>;

const DemoOutboxMessages = Type.Array(DemoOutboxMessageSchema);

export const encodeDemoOutbox = (messages: readonly DemoOutboxMessage[]): string =>
  encodeURIComponent(JSON.stringify(messages));

export const decodeDemoOutbox = (header: string | undefined): readonly DemoOutboxMessage[] => {
  if (header === undefined) return [];
  const messages: unknown = JSON.parse(decodeURIComponent(header));
  return Value.Check(DemoOutboxMessages, messages) ? messages : [];
};
